import Network from '@/services/network'

export default function handleDropdowns() {
    const network = new Network;

    const fetchProductDropdownList = (query) => {
        return network.api('get', '/dropdowns/products'+query);
    }

    const fetchContactProfileDropdownList = (query) => {
        return network.api('get', '/dropdowns/contact-profile-names'+query);
    }

    const fetchActivitySetupEndpoint = (query) => {
        return network.api('get', '/dropdowns/activity-setup-endpoint'+query);
    }

    return {
        fetchProductDropdownList,
        fetchContactProfileDropdownList,
        fetchActivitySetupEndpoint
    }
}
